import { Capacitor } from '@capacitor/core';
import { getApp } from 'firebase/app';
import { logger } from 'features/logger/logger';

let configured: Promise<void> | undefined;

/**
 * Initialises the default Firestore instance with forced long polling. Must
 * resolve before the Firestore plugin's first call, which otherwise creates
 * the instance with default settings. A failed SDK load is dropped: a call
 * made after the failed import settles imports again; a browser that keeps the
 * failed import returns the same failure.
 */
export const configureFirestore = (): Promise<void> => {
  if (Capacitor.isNativePlatform()) {
    return Promise.resolve();
  }

  configured ??= import('firebase/firestore').then(
    ({ initializeFirestore }) => {
      try {
        initializeFirestore(getApp(), { experimentalForceLongPolling: true });
      } catch (error) {
        logger.warn(
          (error as { code?: unknown } | null | undefined)?.code ===
            'failed-precondition'
            ? 'Firestore was created before its transport was configured'
            : 'Firestore transport could not be configured',
          undefined,
          error as Error
        );
      }
    },
    (error: unknown) => {
      configured = undefined;
      throw error;
    }
  );

  return configured;
};
